import React, { PureComponent } from 'react';
import { Grid, Dialog, Button, DialogContent, DialogActions, Typography, IconButton } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { resetSnackbar, authExtendExpiry, logout } from '../../actions';
import ObiLoadingFlat from './ObiLoadingFlat';
import Countdown, { zeroPad } from 'react-countdown'
import { toClientExpiry } from '../../utility/common/SessionExpiry';

import { withStyles } from "@mui/styles";

const styles = theme => ({
  fab: {
    backgroundColor: theme.palette.grey.main,
    color: theme.palette.grey.contrastText,
    position: 'fixed',
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 2000,
    '&:hover':{
      backgroundColor: theme.palette.grey.dark,
    }
  },
  extendedIcon: {

  },
});

class ExtendSession extends PureComponent {
  handleAction = (event) => {
    event.preventDefault();
    this.props.authExtendExpiry(this.props.token);
  };

  render() {
    const warningTime = parseInt(5 * 60);
    // Expiry is on the server clock; shift it onto the device clock so a wrong device time can't end the session early.
    const expiryDate = toClientExpiry(this.props.expiry, this.props.clockOffset) - warningTime;

    const renderer = ({total, hours, minutes, seconds, completed, api, formatted}) => {
      //console.log(total+' ===== '+hours+":"+minutes+":"+seconds);
      if (api.isCompleted() || api.isStopped() || api.isPaused()){
        api.start();
        return false;
      }
      if (total < 0) {
        const timeLeft = ((warningTime * 1000) + total) / 1000;
        if(timeLeft < 0){
          this.props.logout(this.props.type);
          return false;
        }
        const secondsLeft = Math.abs(timeLeft % 60);
        const minutesLeft = parseInt(timeLeft / 60);
        const timeRemaining = minutesLeft+":"+zeroPad(secondsLeft);
        return <ExtendSessionDialog {...this.props} timeRemaining={timeRemaining} handleAction={this.handleAction}/>;
      }
      return false;
    }

    return (<Countdown 
              date={expiryDate * 1000}
              renderer={renderer}
              autoStart={false}
              overtime={true}
            />);
  }
}

const ExtendSessionDialog = (props) => {
  return (<Dialog
    open={true}
    aria-label="session is about to expire"
    maxWidth={'sm'}
  >
    <form onSubmit={props.handleAction}>
      <DialogContent>
        <Grid container justifyContent={'center'} alignItems={'center'}>
          <Grid item xs={6} container justifyContent='flex-end'><IconButton><AccessTimeIcon fontSize='large'/></IconButton></Grid>
          <Grid item xs={6} container justifyContent='flex-start'><Typography align="center">{props.timeRemaining}</Typography></Grid>
        </Grid>
        <Typography>Your session is about to expire.</Typography>
      </DialogContent>
      <DialogActions>
        <Button type="submit" disabled={props.loading} fullWidth={true} variant="contained" color="primary">
          {props.loading? <ObiLoadingFlat /> : 'Extend Session'}
        </Button>
      </DialogActions>
    </form>
  </Dialog>);
  };

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    type: state.auth.user.TYPE,
    token: state.auth.token,
    expiry: state.auth.expiry,
    clockOffset: state.auth.clockOffset,
    loading: state.general.loading,
  };
};

export default withStyles(styles, { withTheme: true }) (connect(mapStateToProps, {
  resetSnackbar,
  authExtendExpiry,
  logout
})(withRouter(ExtendSession)));
